<template>
  <div class="app-container">
    <!--流程流转记录-->
    <el-card class="box-card" v-if="flowRecordList">
      <div slot="header" class="clearfix">
        <span class="el-icon-notebook-1">审批记录</span>
      </div>
      <el-col :span="16" :offset="4">
        <div class="block">
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in flowRecordList"
              :key="index"
              :icon="setIcon(item.finishTime)"
              :color="setColor(item.finishTime)"
            >
              <p style="font-weight: 700">{{ item.taskName }}</p>
              <el-card :body-style="{ padding: '10px' }">
                <label v-if="item.startUserName" style="font-weight: normal; margin-right: 30px"
                  >操作人： {{ item.startUserName }}</label
                >
                <label v-if="item.assigneeName" style="font-weight: normal; margin-right: 30px"
                  >实际办理： {{ item.assigneeName }}
                  <el-tag type="info" size="mini">{{ item.deptName }}</el-tag></label
                >
                <label v-if="item.candidate" style="font-weight: normal; margin-right: 30px"
                  >候选办理： {{ item.candidate }}</label
                >
                <label style="font-weight: normal">接收时间： </label
                ><label style="color: #8a909c; font-weight: normal">{{ item.createTime }}</label>
                <label v-if="item.finishTime" style="margin-left: 30px; font-weight: normal"
                  >办结时间： </label
                ><label style="color: #8a909c; font-weight: normal">{{ item.finishTime }}</label>
                <label v-if="item.duration" style="margin-left: 30px; font-weight: normal"
                  >耗时： </label
                ><label style="color: #8a909c; font-weight: normal">{{ item.duration }}</label>

                <p v-if="item.comment">
                  <el-tag type="success" v-if="item.comment.type === '1'">
                    {{ item.comment.comment }}</el-tag
                  >
                  <el-tag type="warning" v-if="item.comment.type === '2'">
                    {{ item.comment.comment }}</el-tag
                  >
                  <el-tag type="danger" v-if="item.comment.type === '3'">
                    {{ item.comment.comment }}</el-tag
                  >
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="el-icon-picture-outline">流程图</span>
      </div>
      <flow :xmlData="xmlData" :taskData="taskList"></flow>
    </el-card>
  </div>
</template>

<script>
  import flow from './flow';
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  // import Treeselect from '@riophae/vue-treeselect';

  export default {
    name: 'Record',
    components: {
      flow,
      // Treeselect,
    },
    props: {},
    data() {
      return {
        // 模型xml数据
        xmlData: '',
        taskList: [],
        // 部门名称
        deptName: undefined,
        // 部门树选项
        deptOptions: undefined,
        // 用户表格数据
        userList: null,
        defaultProps: {
          children: 'children',
          label: 'label',
        },
        // 查询参数
        queryParams: {
          deptId: undefined,
        },
        // 遮罩层
        loading: true,
        flowRecordList: [], // 流程流转数据
        formConfCopy: {},
        src: null,
        rules: {}, // 表单校验
        variablesForm: {}, // 流程变量数据
        taskForm: {
          returnTaskShow: false, // 是否展示回退表单
          delegateTaskShow: false, // 是否展示回退表单
          defaultTaskShow: true, // 默认处理
          sendUserShow: false, // 审批用户
          multiple: false,
          comment: '', // 意见内容
          procInsId: '', // 流程实例编号
          instanceId: '', // 流程实例编号
          deployId: '', // 流程定义编号
          taskId: '', // 流程任务编号
          procDefId: '', // 流程编号
          vars: '',
          targetKey: '',
        },
        userDataList: [], // 流程候选人
        assignee: null,
        formConf: {}, // 默认表单数据
        formConfOpen: false, // 是否加载默认表单数据
        variables: [], // 流程变量数据
        variablesData: {}, // 流程变量数据
        variableOpen: false, // 是否加载流程变量数据
        returnTaskList: [], // 回退列表数据
        completeTitle: null,
        completeOpen: false,
        returnTitle: null,
        returnOpen: false,
        rejectOpen: false,
        rejectTitle: null,
        userData: [],
        checkSendUser: false, // 是否展示选择人员模块
      };
    },
    created() {
      this.taskForm.deployId = this.$route.query && this.$route.query.deployId;
      this.taskForm.taskId = this.$route.query && this.$route.query.taskId;
      this.taskForm.procInsId = this.$route.query && this.$route.query.procInsId;
      this.taskForm.instanceId = this.$route.query && this.$route.query.procInsId;
      // 初始化表单
      this.taskForm.procDefId = this.$route.query && this.$route.query.procDefId;
      // 回显流程记录
      this.getFlowViewer(this.taskForm.procInsId);
      this.getModelDetail(this.taskForm.deployId);
      this.getFlowRecordList(this.taskForm.procInsId, this.taskForm.deployId);
    },
    mounted() {},
    methods: {
      /** 查询用户列表 */
      getList() {
        this.$axios
          .get('/maindata/system/user/list', this.addDateRange(this.queryParams, this.dateRange))
          .then((response) => {
            this.userList = response.rows;
            this.total = response.total;
          });
      },
      /** xml 文件 */
      getModelDetail(deployId) {
        // 发送请求，获取xml
        this.$axios.get(`/maindata/flowable/definition/readXml/${deployId}`).then((res) => {
          this.xmlData = res.data.data;
        });
      },
      getFlowViewer(procInsId) {
        this.$axios.get(`/maindata/flowable/task/flowViewer/${procInsId}`).then((res) => {
          this.taskList = res.data.data;
        });
      },
      setIcon(val) {
        if (val) {
          return 'el-icon-check';
        } else {
          return 'el-icon-time';
        }
      },
      setColor(val) {
        if (val) {
          return '#2bc418';
        } else {
          return '#b3bdbb';
        }
      },
      /** 流程流转记录 */
      getFlowRecordList(procInsId, deployId) {
        const params = { procInsId: procInsId, deployId: deployId };
        this.$axios
          .get('/maindata/flowable/task/flowRecord', params)
          .then((res) => {
            this.flowRecordList = res.data.data.flowList;
          })
          .catch(() => {
            this.goBack();
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .test-form {
    margin: 15px auto;
    width: 800px;
    padding: 15px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }
  .clearfix:after {
    clear: both;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }
</style>
